module.exports = __webpack_public_path__ + "static/media/about-us-background.f7415ae3.png";